import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "commonComponents/btWrappers/BTIcon";
import { useBaseIcon } from "commonComponents/btWrappers/BTIcon/BTIcon.utilities";
import SVG from "commonComponents/btWrappers/BTIcon/images/PersonMinus.svg?react";

export const BTIconPersonMinus: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    // eslint-disable-next-line react/forbid-elements
    return <Icon {...props} component={SVG} />;
};
